





































































































































































































import {Component, Prop, Mixins} from 'vue-property-decorator'
import ContractDappCellRender from '@/components/render/ContractDappCellRender.vue'
import {$} from '@/facade'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitProject} from '@/model/resource/OrbitProject'

@Component({
  components: {
    ContractDappCellRender,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class DappDetailedOrbitScrollableTable extends Mixins(
  MixinScreenSize
) {
  @Prop({type: Array, required: true}) items!: OrbitProject[]
  @Prop({type: Object, required: true}) transactionCountMap!: Record<
    number,
    {
      total: string
      your: string
    }
  >

  copyToClipboard(scriptHash: string) {
    this.$utils.copyToClipboard(scriptHash)
    this.$toast.info('system.info.copiedToClipboard')
  }

  formattedHash(hash: string) {
    if (!hash) return

    if (!this.isLessThanTablet) return hash

    return `${hash.slice(0, 5)}...${hash.slice(-5)}`
  }

  getYourTxs(item: OrbitProject): string {
    if (!item.idOrbitProjectPk) return '0'
    return String(this.transactionCountMap[item.idOrbitProjectPk]?.your ?? '0')
  }

  getTotalTxs(item: OrbitProject): string {
    if (!item.idOrbitProjectPk) return '0'
    return String(this.transactionCountMap[item.idOrbitProjectPk]?.total ?? '0')
  }
}
